import 'css-chunk:src/app/containers/Members/AddMember/NewAddMemberHeader.scss';export default {
  "header": "_header_1j49e_1",
  "closeBtn": "_closeBtn_1j49e_5",
  "label": "_label_1j49e_12",
  "row": "_row_1j49e_17"
};